// eslint-disable-next-line import/extensions
import Toolbar from '@/components/Toolbar/Toolbar';

export default {
  name: 'App',
  components: {
    Toolbar,
  },
  props: {},
  data: () => ({}),
  computed: {},
  methods: {},
};
